function isEmailValid(value: any) {
  const validation = value;
  const regex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
  const validacao = regex.test(validation);
  if (validacao) return true;
  return false;
}

export { isEmailValid };
